<mat-card class="card">
  <div *ngIf="step === 1">
  <h2 style="text-align: center;">{{'RP_T1' | translate}}</h2>
  <form style="margin-bottom: 1rem;" [formGroup]="completeRegisterForm">
    <p class="label" [ngClass]="{'label-err': errPass  || errDontMatch}">Password</p>
    <input type="password" placeholder="Password" formControlName='password' (focus)="clearErr('pass')"
      (focusout)="focusOutCheck('pass')" [ngClass]="{'error': errPass || errDontMatch}">
      <p *ngIf="errPass" class="error-text">{{errPass}}</p>
    <p class="label" [ngClass]="{'label-err': errConfPass || errDontMatch}">{{'RP_P1' | translate}}</p>
    <input type="password" placeholder="{{'RP_P1' | translate}}" formControlName='confirmPassword' (focus)="clearErr('confPass')"
      (focusout)="focusOutCheck('confPass')" [ngClass]="{'error': errConfPass || errDontMatch}">
    <p *ngIf="errConfPass" class="error-text">{{errConfPass}}</p>
    <p *ngIf="errDontMatch" class="error-text">{{errDontMatch}}</p>
  </form>
  <div class="buttons">
    <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
    <button mat-raised-button class="consentButton" (click)="confirm()"> {{'LOG_ON_B1' | translate}}</button>
  </div>
</div>
<div *ngIf="step === 2">
  <h2 style="text-align: center;">{{'RP_T2' | translate}}</h2>
  <p>{{'RP_P2' | translate}}</p>
</div>
</mat-card>